(ns teamoesterreich.user-mode.actions
  (:require
    [cljs-uuid-utils.core :as uuid]
    [clojure.string :as str]
    [reagent.core :as r]
    [shadow.cljs.modern :refer (js-await)]
    [teamoesterreich.actions.auth :as a-auth]
    [teamoesterreich.actions.backend-requests :as a-b-req]
    [teamoesterreich.actions.page-flow :as a-pageFlow]
    [teamoesterreich.config :as config]
    [teamoesterreich.firebase.provider :as fs-provider]
    [teamoesterreich.store :as store]
    [teamoesterreich.util.geo-helper :as geo-helper]
    [teamoesterreich.util.log :as log]
    ))




(def bottom-bar-back-action-set (fn [_ _]))

(defn register-bottom-bar-back-action-set [bottom-bar-back-action-set_]
  (set! bottom-bar-back-action-set bottom-bar-back-action-set_))

(defn logout []
  (a-auth/logout))

(defn set-no-back-page [new-page]
  (a-pageFlow/set-no-back-page new-page))


(defn go-home []
  (println "go-home -->" (get @store/app-state :home-target))
  (set-no-back-page (get @store/app-state :home-target))
  )

(defn get-page []
  (a-pageFlow/get-page)
  )

(defn set-page [new-page & [back-button-page]]
  (a-pageFlow/set-page new-page back-button-page))

(defn set-page-back []
  (a-pageFlow/set-page-back))

(defn set-bottom-action-fn [back-fn & [action-fn]]
  (bottom-bar-back-action-set back-fn action-fn)
  )


(defn set-page-by-path [new-page]
  (when (not= (get-page) new-page) (do
                                     (log/debug "set-page-by-path changed path: set-page " (get-page) " -> " new-page)
                                     (set-page new-page))))

(defn open-login []
  (a-auth/open-login))

(defn set-user-details [obj]
  (js-await [_ (fs-provider/update-fs-user obj)]
    (a-b-req/sync-firestore)))
(defn set-location [location-id location-obj]
  (js-await [_ (fs-provider/update-fs-location location-id location-obj)]
    (a-b-req/sync-firestore)))


(defn set-user-fav-location [locationId location]
  (if (:zip location)
    (fs-provider/update-fs-user {:main_address          location
                                 :user-addressLongitude (.-_lng ^js (get-in location [:coordinates]))
                                 :user-addressLatitude  (.-_lat ^js (get-in location [:coordinates]))})
    (geo-helper/geo-lookup (:address location)
                           (fn [d]
                             (fs-provider/edit-location locationId d)
                             (fs-provider/update-fs-user {:main_address          d
                                                          :user-addressLongitude (.-_lng ^js (get-in d [:coordinates]))
                                                          :user-addressLatitude  (.-_lat ^js (get-in d [:coordinates]))}))

                           ))

  (fs-provider/set-user-fav-location locationId)
  )
(defn get-location-ref [locationId] (fs-provider/get-location-ref locationId))


(defn add-shopping-item [itemId item-obj] (fs-provider/add-shopping-item itemId item-obj))
(defn add-action-list-item [itemId item-obj] (fs-provider/add-action-list-item itemId item-obj))

(defn create-location [loc-obj success-fn]
  (js-await [_ (fs-provider/create-location loc-obj success-fn)]
    (a-b-req/sync-firestore)))
(defn edit-location [locationId loc-obj] (fs-provider/edit-location locationId loc-obj))
(defn drop-location [locationId] (fs-provider/drop-location locationId))


(defn set-user-crowdtasker-response [crowdtaskerId data] (fs-provider/set-user-crowdtasker-response crowdtaskerId data))

(defn set-user-crowdtasker-response-direct [crowdtaskerId data on-success]
  (let [!actual-user (r/cursor store/app-state [:actual-user])]
    (a-b-req/set-user-crowdtasker-response (:tom-id @!actual-user) crowdtaskerId data on-success)))

(defn get-user-crowdtasker-response [eventUuid tomId on-success & [on-failed]]
  (a-b-req/get-user-crowdtasker-response eventUuid tomId on-success on-failed))

(defn set-user-questionnaire-response [questionnaireId data] (fs-provider/set-user-questionnaire-response questionnaireId data))
(defn set-user-questionnaire-question-response [questionnaireId questionId data] (fs-provider/set-user-questionnaire-question-response questionnaireId questionId data))
(defn set-user-questionnaire-answer [questionnaireId questionId answerOptionId data] (fs-provider/set-user-questionnaire-answer questionnaireId questionId answerOptionId data))


(defn set-user-location-questionnaire-response [locationId questionnaireId data] (fs-provider/set-user-location-questionnaire-response locationId questionnaireId data))
(defn set-user-location-questionnaire-question-response [locationId questionnaireId questionId data] (fs-provider/set-user-location-questionnaire-question-response locationId questionnaireId questionId data))
(defn set-user-location-questionnaire-answer [locationId questionnaireId questionId answerOptionId data] (fs-provider/set-user-location-questionnaire-answer locationId questionnaireId questionId answerOptionId data))


(defn set-user-document [documentId item-obj]
  (js-await [_ (fs-provider/set-user-document documentId item-obj)]
    (a-b-req/sync-firestore)))
(defn add-user-document [item-obj]
  (let [new-uuid (uuid/make-random-uuid)]
    (js-await [_ (fs-provider/add-user-document new-uuid item-obj)]
      (a-b-req/sync-firestore))))




(defn get-lebensretter-link [done-fn]
  (a-b-req/get-lebensretter-link done-fn))

(defn send-lebensretter-link [done-fn]
  (a-b-req/send-lebensretter-link done-fn))
(defn get-lebensretter-selfexplain-link [done-fn]
  (a-b-req/send-lebensretter-selfexplain-link done-fn))

(def kc-redirect-uri (str/join "/" [config/PUBLIC_BASE_URL "oauth/post-login"]))
(defn set-redirect-uri [mode]
  (case mode
    :user (set! kc-redirect-uri (str/join "/" [config/PUBLIC_BASE_URL "oauth/post-login"]))
    :event (set! kc-redirect-uri (str/join "/" [config/PUBLIC_BASE_URL "oauth/post-login/event"]))
    :lebensretter (set! kc-redirect-uri (str/join "/" [config/PUBLIC_BASE_URL "oauth/post-login/lebensretter"]))))

(defn update-email []
  (.signinRedirect config/user-manager #js{:extraQueryParams #js{:kc_action "UPDATE_EMAIL"} :redirect_uri kc-redirect-uri}))

(defn verify-email []
  (.signinRedirect config/user-manager #js{:extraQueryParams #js{:kc_action "VERIFY_EMAIL"} :redirect_uri kc-redirect-uri}))

(defn update-phone-number []
  (.signinRedirect config/user-manager #js{:extraQueryParams #js{:kc_action "update-phone-number"} :redirect_uri kc-redirect-uri}))

(defn verify-phone-number []
  (.signinRedirect config/user-manager #js{:extraQueryParams #js{:kc_action "verify-phone-number"} :redirect_uri kc-redirect-uri}))

(defn change-password []
  (.signinRedirect config/user-manager #js{:extraQueryParams #js{:kc_action "UPDATE_PASSWORD"} :redirect_uri kc-redirect-uri}))

;(set! js/getPageInfo get-page-info)








